






















import Vue from "vue";
import MainColumns from "@/components/templates/MainColumns.vue";
import Notifications from "@/components/organisms/Notifications.vue";
import RoomWizard from "@/components/organisms/wizard/RoomWizard.vue";
import WizardConnect from "@/components/organisms/wizard/WizardConnect.vue";
import { DeviceConfiguration } from "@/models/deviceConfiguration";

export default Vue.extend({
  name: "changeLicense",
  data() {
    return {
      deviceConfiguration: undefined as DeviceConfiguration | undefined,
      steps: ["license", "complete"],
    };
  },
  components: {
    WizardConnect,
    RoomWizard,
    Notifications,
    MainColumns,
  },
});
